module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Charlotte Elwood is an Australian author whose life story is as captivating as the tales she weaves. Born into the challenges of poverty, she exemplifies resilience, determination, and the unwavering pursuit of knowledge. Charlotte’s sense of adventure, hope, and boundless curiosity have driven her to explore the darkest corners of humanity’s stories, shedding light on the misunderstood and marginalized. With a heart as kind as it is diligent, she embodies the belief that even the most challenging circumstances can fuel the brightest aspirations for the future.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0